import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { formatApiError } from "../api/client";
import logoMark from "../assets/logo-mark.png";

export const LoginPage = ({ onForgotPassword }) => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email, password);
    } catch (ex) {
      setErr(formatApiError(ex));
    } finally {
      setBusy(false);
    }
  };

  const inputStyle = {
    background: "var(--surface-card)",
    borderColor: "var(--border-default)",
    color: "var(--ink-primary)",
  };
  const inputCls =
    "w-full rounded-md border px-3 py-2 text-base transition-colors focus:outline-none focus:border-[var(--brand-primary)] focus:ring-2 focus:ring-[color:var(--brand-primary)]/25";

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: "var(--surface-page)" }} data-testid="login-page">
      <div
        className="w-full max-w-md rounded-lg p-7"
        style={{
          background: "var(--surface-card)",
          border: "1px solid var(--border-default)",
          boxShadow: "var(--shadow-card)",
        }}
      >
        <div className="flex items-center gap-3 mb-1">
          <img src={logoMark} alt="" width={48} height={48} className="rounded-md object-contain" />
          <div>
            <h1
              className="leading-tight"
              style={{
                fontFamily: "var(--font-display)",
                fontSize: "var(--text-heading)",
                fontWeight: "var(--weight-bold)",
                color: "var(--ink-primary)",
                letterSpacing: "var(--tracking-tight)",
              }}
            >
              Four Hundred Club
            </h1>
            <p className="text-xs" style={{ color: "var(--ink-tertiary)" }}>Red Hook Rhinebeck Elks Lodge #2022</p>
          </div>
        </div>
        <p className="mt-5 mb-4 text-sm" style={{ color: "var(--ink-secondary)" }}>Sign in to continue.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-sm font-medium mb-1.5 block" style={{ color: "var(--ink-primary)" }}>Email</label>
            <input
              data-testid="login-email"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={inputCls}
              style={inputStyle}
            />
          </div>
          <div>
            <label className="text-sm font-medium mb-1.5 block" style={{ color: "var(--ink-primary)" }}>Password</label>
            <input
              data-testid="login-password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={inputCls}
              style={inputStyle}
            />
          </div>
          {err && <p data-testid="login-error" className="text-sm font-medium" style={{ color: "var(--semantic-danger)" }}>{err}</p>}
          <button
            data-testid="login-submit"
            type="submit"
            disabled={busy}
            className="w-full px-5 py-2.5 text-sm font-medium rounded-md transition-colors disabled:opacity-50"
            style={{ background: "var(--brand-primary)", color: "var(--ink-on-brand)" }}
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <button
          type="button"
          onClick={onForgotPassword}
          data-testid="login-forgot-link"
          className="mt-4 block text-sm font-medium mx-auto hover:underline"
          style={{ color: "var(--brand-primary)" }}
        >
          Forgot password?
        </button>
        <p className="mt-6 text-xs text-center" style={{ color: "var(--ink-tertiary)" }}>
          Need an account? Ask the lodge administrator.
        </p>
      </div>
    </div>
  );
};
